export function commitRender(renderResult) {
    const errors = [];
    for (const task of renderResult.commitTasks) {
        try {
            task();
        }
        catch (error) {
            errors.push(error);
        }
    }
    if (errors.length > 0) {
        if (errors.length === 1) {
            throw errors[0];
        }
        else {
            for (const error of errors) {
                console.error(error);
            }
            throw new AggregateError(errors, "Errors during commit");
        }
    }
}
export function cleanupAllEffects(executionContext) {
    const errors = [];
    for (const cell of executionContext.cells) {
        if (cell?.type === "effect") {
            cell.deps = null; // Reset deps so effect runs again on next mount
            if (cell.cleanup) {
                try {
                    cell.cleanup?.();
                }
                catch (e) {
                    errors.push(e);
                }
                finally {
                    cell.cleanup = undefined;
                }
            }
        }
    }
    if (errors.length > 0) {
        if (errors.length === 1) {
            throw errors[0];
        }
        else {
            for (const error of errors) {
                console.error(error);
            }
            throw new AggregateError(errors, "Errors during cleanup");
        }
    }
}
//# sourceMappingURL=commit.js.map